import React from "react";
import Stack from "@mui/material/Stack";
import styles from "./styles";
import MatchingStatus from "./Status";
import MatchCard from "./MatchCard";
import { useMatching } from "../MatchingProvider";
import { Typography } from "@mui/material";

const Wrapper = ({ children }) => (
  <Stack component="section" sx={styles}>
    <Typography variant="body2">
      Review and approve recommended therapy schedules for clinicians. Matching results update each
      day.
    </Typography>
    {children}
  </Stack>
);

/**
 * The MatchPanel component conditionally renders a list of generated schedules or a message indicating
 * no schedules were found, along with a refresh button.
 * @param {Object} props - The props object.
 * @returns {JSX.Element} - The MatchPanel component.
 */
const MatchPanel = ({ setShowCaseload }) => {
  const { generatedSchedules, generatedSchedulesLoading, setSelectedClinician, noMatchesCreated } =
    useMatching();

  // auto-select the first clinician when the data is loaded for the first time
  const initialDataLoadedRef = React.useRef(false);
  React.useEffect(() => {
    if (generatedSchedules?.length && !initialDataLoadedRef.current) {
      initialDataLoadedRef.current = true;
      setSelectedClinician(generatedSchedules[0].clinician_id);
    }
  }, [generatedSchedules]);

  if (generatedSchedulesLoading) {
    return (
      <Wrapper>
        <Stack direction="column" spacing={2} justifyContent="center" flexGrow={1}>
          <MatchingStatus.Loading />
        </Stack>
      </Wrapper>
    );
  }

  if (noMatchesCreated) {
    return (
      <Wrapper>
        <Stack direction="column" spacing={2} justifyContent="center" height="100%">
          <MatchingStatus.NoFound />
        </Stack>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {generatedSchedules.length ? (
        <Stack pt={7} gap={5}>
          {generatedSchedules?.map((generatedSchedule) => (
            <MatchCard
              key={generatedSchedule.clinician_id}
              generatedSchedule={generatedSchedule}
              setShowCaseload={setShowCaseload}
            />
          ))}
        </Stack>
      ) : (
        <Stack direction="column" spacing={2} justifyContent="center" flexGrow={1}>
          <MatchingStatus.Empty />
        </Stack>
      )}
    </Wrapper>
  );
};

export default MatchPanel;
